import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=3b99f0a6"
import script from "./HelpCenter.ts?vue&type=script&lang=js&external"
export * from "./HelpCenter.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports